import { cn } from '@/lib/utils';

interface LogoMarkProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export function LogoMark({ className, size = 'md' }: LogoMarkProps) {
  const sizes = {
    sm: 'w-6 h-6',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(sizes[size], className)}
    >
      <defs>
        <linearGradient id="grad1" x1="100%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#1E2D3B" />
          <stop offset="100%" stopColor="#004D60" />
        </linearGradient>
        <linearGradient id="grad2" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#004D60" />
          <stop offset="100%" stopColor="#3ABAA5" />
        </linearGradient>
        <linearGradient id="grad3" x1="0%" y1="100%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#3ABAA5" />
          <stop offset="100%" stopColor="#8DC63F" />
        </linearGradient>
        <linearGradient id="grad4" x1="100%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#8DC63F" />
          <stop offset="100%" stopColor="#1E2D3B" />
        </linearGradient>
      </defs>
      <g fill="none" strokeWidth="8" strokeLinecap="round" transform="rotate(-30 100 100)">
        <path d="M 100,25 A 75,75 0 0,0 25,100" stroke="url(#grad1)" />
        <path d="M 25,100 A 75,75 0 0,0 100,175" stroke="url(#grad2)" />
        <path d="M 100,175 A 75,75 0 0,0 170.5,125.6" stroke="url(#grad3)" />
        <path d="M 170.5,74.4 A 75,75 0 0,0 100,25" stroke="url(#grad4)" />
      </g>
      <path
        d="M 153,60 L 163,70 L 180,46"
        fill="none"
        stroke="#8DC63F"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

interface LogoWhiteMarkProps {
  className?: string;
}

export function LogoWhiteMark({ className }: LogoWhiteMarkProps) {
  return (
    <svg
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('w-8 h-8', className)}
    >
      <g fill="none" strokeWidth="8" strokeLinecap="round" transform="rotate(-30 100 100)">
        <path d="M 100,25 A 75,75 0 0,0 25,100" stroke="#FFFFFF" />
        <path d="M 25,100 A 75,75 0 0,0 100,175" stroke="#FFFFFF" />
        <path d="M 100,175 A 75,75 0 0,0 170.5,125.6" stroke="#FFFFFF" />
        <path d="M 170.5,74.4 A 75,75 0 0,0 100,25" stroke="#FFFFFF" />
      </g>
      <path
        d="M 153,60 L 163,70 L 180,46"
        fill="none"
        stroke="#8DC63F"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
